export default __webpack_public_path__ + "remove-symbol.png";